import React, { useState } from "react";
import AccessibleModal from "../AccessibleModal";
import CustomerPicker from "../CustomerPicker";
import { CustomerMembershipManager } from "../../pages/CustomersPage";
import { db } from "../../firebase";
import { findOrCreateCustomerForBusiness, normalizePhone } from "../../utils/customerCrm";
import "./ReportMembershipEnrollment.css";

export default function ReportMembershipEnrollment({ businessId, onClose, customers }) {
  const [mode, setMode] = useState("search");
  const [draft, setDraft] = useState({ name: "", phone: "", email: "" });
  const [selected, setSelected] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const create = async (event) => {
    event.preventDefault();
    if (busy) return;
    setBusy(true); setError("");
    try {
      const phone = normalizePhone(draft.phone);
      if (!phone || phone.replace(/\D/g, "").length < 8) throw new Error("Revisa el teléfono e incluye el código de país.");
      const result = await findOrCreateCustomerForBusiness(db, businessId, { name: draft.name.trim(), phone, email: draft.email.trim() }, { source: "membership_report" });
      setSelected(result); setCustomer(result);
    } catch (err) { setError(err.message || "No pudimos registrar al cliente."); }
    finally { setBusy(false); }
  };
  return <AccessibleModal open layer="stacked" labelledBy="report-enrollment-title" onClose={busy ? undefined : onClose} width={760} dialogClassName="report-enrollment">
    <header><h2 id="report-enrollment-title">Agregar membresía</h2><button type="button" aria-label="Cerrar" disabled={busy} onClick={onClose}>×</button></header>
    {customer ? <>
      <div className="report-enrollment-contact"><strong>{customer.name}</strong><span>{customer.email || "Sin correo"} · {customer.phone || "Sin teléfono"}</span></div>
      <CustomerMembershipManager key={customer.id} businessId={businessId} customer={customer} onClose={() => setCustomer(null)} />
    </> : <div className="report-enrollment-body">
      <nav aria-label="Cliente"><button type="button" aria-pressed={mode === "search"} onClick={() => { setMode("search"); setError(""); }}>Buscar cliente</button><button type="button" aria-pressed={mode === "new"} onClick={() => { setMode("new"); setError(""); }}>Crear cliente</button></nav>
      {mode === "search" ? <>
        <CustomerPicker crmCustomers={customers} businessId={businessId} value={draft.name} onChange={(value) => { setDraft({ name: value.customerName || "", phone: value.customerPhone || "", email: value.customerEmail || "" }); setSelected(value.customerId ? { ...value.customerSnapshot, id: value.customerId } : null); }} onUseNewCustomer={() => setMode("new")} />
        {selected && <p>{selected.email || "Sin correo"} · {selected.phone || "Sin teléfono"}</p>}
        <button className="report-enrollment-primary" type="button" disabled={!selected} onClick={() => setCustomer(selected)}>Continuar con este cliente</button>
      </> : <form onSubmit={create}>
        <label>Nombre<input required minLength={2} value={draft.name} onChange={(e) => setDraft({ ...draft, name: e.target.value })} /></label>
        <label>Teléfono<input required type="tel" placeholder="+507 6000 0000" value={draft.phone} onChange={(e) => setDraft({ ...draft, phone: e.target.value })} /></label>
        <label>Correo<input required type="email" value={draft.email} onChange={(e) => setDraft({ ...draft, email: e.target.value })} /></label>
        <small>No necesita una cuenta de Loop. Verificaremos si ya está registrado.</small>
        <button className="report-enrollment-primary" disabled={busy}>{busy ? "Verificando…" : "Guardar cliente y continuar"}</button>
      </form>}
      {error && <p role="alert">{error}</p>}
    </div>}
  </AccessibleModal>;
}
